import { render, staticRenderFns } from "./SubscriptionCategories.vue?vue&type=template&id=006fcdc4"
import script from "./SubscriptionCategories.vue?vue&type=script&lang=ts"
export * from "./SubscriptionCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports